import { SessionStatusEnum } from "../types";

interface SessionStatusProps {
  status: SessionStatusEnum;
}

const statusConfig = {
  failed: {
    className: "al-text-red-500",
    label: "Failed",
  },
  pending: {
    className: "al-text-gray-400",
    label: "Pending",
  },
  completed: {
    className: "al-text-green-500",
    label: "Completed",
  },
  cancelled: {
    className: "al-text-gray-400",
    label: "Cancelled",
  }
} as const;

export const SessionStatus = ({ status }: SessionStatusProps) => {
  const config = statusConfig[status];

  return <span className={`al-text-xs al-font-medium ${config.className}`}>{config.label}</span>;
};
